import { render, staticRenderFns } from "./SmsObserverList.vue?vue&type=template&id=53cd0af4"
import script from "./SmsObserverList.vue?vue&type=script&lang=js"
export * from "./SmsObserverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports